module.exports = __webpack_public_path__ + "static/media/gradpic.47e3883f.JPG";